import { useMutation } from "react-query";
import axios from "../axios";

const useCreateNewPassword = ({ onSuccess, onError }) => {
  const mutation = useMutation(
    async (params) => {
      return await axios.put("/api/auth/create-new-password", {
        token: params.token,
        password: params.password,
      });
    },
    {
      onSuccess: (res) => onSuccess(res),
      onError: (err) => onError(err),
    }
  );

  return mutation;
};

export default useCreateNewPassword;
